import { useContext } from 'react';
import { QuotesContext } from '../context/QuotesContext';

export const useQuoteContext = () => {
  const context = useContext(QuotesContext);
  // Return context if available, otherwise return default empty state
  if (!context) {
    return {
      quoteList: { quotes: [] },
      loading: false,
      error: null,
      isRefreshing: false
    };
  }
  return context;
};